import classNames from "classnames";
import { ButtonHTMLAttributes, PropsWithChildren } from "react";

const baseButtonClassName =
  "mx-2 flex rounded px-4 py-4 text-[16px] cursor-pointer";

const getVariantClassName = ({
  color,
  disabled,
}: {
  color: "danger" | "proceed";
  disabled?: boolean;
}) => {
  if (disabled) {
    return "cursor-not-allowed bg-gray-500 text-white";
  }

  if (color === "danger") {
    return "bg-red-500 text-white";
  }

  return "bg-[darkblue] text-white";
};

interface ButtonProps {
  onClick: () => void;
  type: "danger" | "proceed";
  label: string;
  disabled?: boolean;
  className?: string;
}

const Button = (props: ButtonProps) => {
  return (
    <button
      className={classNames(
        baseButtonClassName,
        getVariantClassName({ color: props.type, disabled: props.disabled }),
        props.className
      )}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.label}
    </button>
  );
};

export default Button;

interface Button2Props
  extends PropsWithChildren,
    Omit<ButtonHTMLAttributes<HTMLButtonElement>, "color"> {
  color: "danger" | "proceed";
}

const Button2 = ({ color, className, disabled, children, ...props }: Button2Props) => {
  return (
    <button
      {...props}
      disabled={disabled}
      className={classNames(
        baseButtonClassName,
        getVariantClassName({ color, disabled }),
        className
      )}
    >
      {children}
    </button>
  );
};

export { Button2 };
